module.exports = __webpack_public_path__ + "img/cover.4b6ebfde.png";